import { ComputedQueryFull, FiltersMap } from '@wix/bex-core';
import { ReactElement } from 'react';

export interface BulkActionModalRenderPropParams<T, F extends FiltersMap> {
  /**
   * Opens the modal .
   */
  openModal: () => void;
  /**
   * Closes the modal.
   */
  closeModal: () => void;
  closeModalAndScrollTop: () => void;
  /**
   * return true if the modal is open
   */
  readonly isModalOpen: boolean;
  /**
   * return boolean value Whether the Select All option is selected.
   */
  readonly allSelected: boolean;
  /**
   * Selected item values.
   */
  readonly selectedValues: T[];
  /**
   *  Unselected item values.
   */
  readonly uncheckedValues: T[];
  scrollToTop: () => void;
  /**
   * Instance of [ComputedQuery](./?path=/story/common-types--computedquery) that represents the query that resulted in an empty state.
   * Representation of the current paging, sorting and filtering applied. Usually for using together with bulk action such as `updateAll` and `deleteAll`.
   * @overrideType [ComputedQuery](./?path=/story/common-types--computedquery)
   */
  query: ComputedQueryFull<F>;
}

export type BulkActionModalRenderProp<T, F extends FiltersMap> = (
  params: BulkActionModalRenderPropParams<T, F>,
) => ReactElement;
